import script from "./SystemPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemPortal.vue?vue&type=script&setup=true&lang=js"

import "./SystemPortal.vue?vue&type=style&index=0&id=3b222fde&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b222fde"]])

export default __exports__